function NoPage() {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="text-center">
        <h1 className="display-1 fw-bold">404</h1>
        <p className="fs-3"> <span className="text-danger">Opps!</span> La página no fue encontrada.</p>
        <p className="lead">
          La página donde intentas acceder, no existe.. 😅
        </p>
        <a href="/" className="btn btn-primary">Inicio</a>
      </div>
    </div>
  );
}

export default NoPage;